import { render, staticRenderFns } from "./VotingCode.vue?vue&type=template&id=6136e467&scoped=true&"
import script from "./VotingCode.vue?vue&type=script&lang=js&"
export * from "./VotingCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136e467",
  null
  
)

export default component.exports